'use strict';

import { parsePhoneNumber } from 'libphonenumber-js';

export default {
  name: 'ValidationMixin',

  methods: {
    isValidPhoneNumber(num) {
      return this.validatePhoneNumber(num);
    },

    validatePhoneNumber(num) {
      let isValid = false;

      try {
        const phoneNumber = parsePhoneNumber(num, 'US');
        isValid = phoneNumber.isValid();
      } catch (e) {
        // ignore
      }

      return isValid || this.$t('errorMessage');
    }
  }
};
